export var UPDATE_PAYLOAD = 'UPDATE_PAYLOAD';
export var UPDATE_RETRY = 'UPDATE_RETRY';
export var UPDATE_RETRY_CONTAINER = 'UPDATE_RETRY_CONTAINER';
export var UPDATE_FLOW = 'UPDATE_FLOW';
export var UPDATE_ISDIDNOTRECEIVECODE = 'UPDATE_ISDIDNOTRECEIVECODE';
export var UPDATE_SMSCHANNEL = 'UPDATE_SMSCHANNEL';
export var UPDATE_VOICECHANNEL = 'UPDATE_VOICECHANNEL';
export var UPDATE_PHONENUMBER = 'UPDATE_PHONENUMBER';
export var UPDATE_POSSIBLETARGETS = 'UPDATE_POSSIBLETARGETS';
export var UPDATE_ISDISCLOSUREVISIBLE = 'UPDATE_ISDISCLOSUREVISIBLE';
export var UPDATE_ISSENDCODEASVOICEENABLED = 'UPDATE_ISSENDCODEASVOICEENABLED';
export var UPDATE_AUTHENTICATIONSTATE = 'UPDATE_AUTHENTICATIONSTATE';
export var UPDATE_PHONESECURITYRESPONSE = 'UPDATE_PHONESECURITYRESPONSE';
export var UPDATE_DONTSEENUMBER = 'UPDATE_DONTSEENUMBER';
export var UPDATE_TARGETS = 'UPDATE_TARGETS';
export var UPDATE_ISAUTHENTICATE = 'UPDATE_ISAUTHENTICATE';
export var UPDATE_SENDOTP = 'UPDATE_SENDOTP';
export var UPDATE_VERIFYOTPSCREEN = 'UPDATE_VERIFYOTPSCREEN';
export var UPDATE_ERRORCONATINER = 'UPDATE_ERRORCONATINER';
export var UPDATE_ERRORMESSAGE = 'UPDATE_ERRORMESSAGE';
export var UPDATE_VERIFYCLICKED = 'UPDATE_VERIFYCLICKED';
export var UPDATE_ISCANCELAUTHENTICATIONENABLED = 'UPDATE_ISCANCELAUTHENTICATIONENABLED';
export var UPDATE_SHOWFAILEDATTEMPTSSCREENONERROR = 'UPDATE_SHOWFAILEDATTEMPTSSCREENONERROR';
export var UPDATE_LANGUAGECODE = 'UPDATE_LANGUAGECODE';
export var UPDATE_OPTEDOUT = 'UPDATE_OPTEDOUT';
export var CHANNEL_MODE = 'CHANNEL_MODE';
export var CLIENT_CONTEXT = 'CLIENT_CONTEXT';
export var UPDATE_SELECTEDTARGET = 'UPDATE_SELECTEDTARGET';
export var UPDATE_OTPATTEMPTS = 'UPDATE_OTPATTEMPTS';
export var UPDATE_HASANALYTICS = 'UPDATE_HASANALYTICS';
export var UPDATE_ANALYTICS = 'UPDATE_ANALYTICS';
export var UPDATE_SFFDL = 'UPDATE_SFFDL';
export var UPDATE_CONFIG = 'UPDATE_CONFIG';
export var UPDATE_PARAMS = 'UPDATE_PARAMS';
export var RESET = 'RESET';
export var UPDATE_OTPCODEVALUE = 'UPDATE_OTPCODEVALUE';
export var UPDATE_APPDATA = 'UPDATE_APPDATA';
export var UPDATE_REQUIREDERRORMSG = 'UPDATE_REQUIREDERRORMSG';
export var UPDATE_IS_LOADING = 'UPDATE_IS_LOADING';
export var UPDATE_SEND_CODE_AS = 'UPDATE_SEND_CODE_AS';
export var UPDATE_OTP_ACTION = 'UPDATE_OTP_ACTION';
export var RESET_OTP_ACTION = 'RESET_OTP_ACTION';
